<template>
	<div>
		<div class="col-lg-12 mb-8">
			<app-overlay-loader v-if="preloader" />
			<div class="row">
				<!-- Class Trial Form -->
				<div class="col-lg-12">
					<div class="mb-4">
						<h4>Class Trial:</h4>
						<hr
							style="
								border-top: 2px solid black;
								font-weight: bold;
							"
						/>
					</div>
					<form
						ref="classTrialForm"
						:data-url="'/transaction/placement/' + props.rowData.id"
						class="mb-0"
						:class="{ 'loading-opacity': preloader }"
					>
						<div class="row">
							<div class="col-lg-12">
								<div class="row">
									<!-- Assigned By -->
									<div class="col-md-6">
										<div class="form-group">
											<label for="inputs_created_by"
												>Assigned By</label
											>
											<app-input
												id="inputs_created_by"
												type="search-select"
												v-model="
													classTrialForm.created_by
												"
												placeholder="Assigned By"
												:list="assignedByLists"
											/>
										</div>
									</div>
									<!-- Completed By -->
									<div class="col-md-6">
										<div class="form-group">
											<label for="inputs_completed_by"
												>Completed By</label
											>
											<app-input
												id="inputs_completed_by"
												type="search-select"
												v-model="
													classTrialForm.completed_by
												"
												placeholder="Completed By"
												:list="completedByLists"
											/>
										</div>
									</div>
								</div>
								<div class="row">
									<!-- CLC Centre -->
									<div class="col-md-6">
										<div class="form-group">
											<label for="inputs_center_id"
												>CLC Centre</label
											>
											<app-input
												id="inputs_center_id"
												type="search-select"
												v-model="
													classTrialForm.center_id
												"
												placeholder="Nearest CLC"
												:list="centerLists"
											/>
										</div>
									</div>
									<!-- Placement Date -->
									<div class="col-md-6">
										<div class="form-group">
											<label>Placement Date</label>
											<app-input
												placeholder="Placement Date"
												type="date"
												name="booked_date"
												v-model="
													classTrialForm.booked_date
												"
											/>
										</div>
									</div>
								</div>
								<div class="row">
									<!-- Class Name -->
									<div class="col-md-6">
										<div class="form-group">
											<label for="inputs_course_id"
												>Class Name</label
											>
											<app-input
												id="inputs_course_id"
												type="advance-search-select"
												:loaded-per-time="10"
												v-model="input_course_id"
												@input="setCourseIdValue"
												fetch-url="transaction/course"
												placeholder="Class"
												list-value-field="course_name"
											/>
										</div>
									</div>
									<!-- Sub Status -->
									<div class="col-md-6">
										<div class="form-group">
											<label for="inputs_sub_status">
												Sub Status
											</label>
											<app-input
												id="inputs_sub_status"
												type="advance-search-select"
												:loaded-per-time="10"
												v-model="input_sub_status"
												@input="setSubStatusValue"
												:fetch-url="`/master/lead-status?lead_status_id=3&per_page=50`"
												:placeholder="'Sub Status'"
												list-value-field="status"
											/>
										</div>
									</div>
								</div>
							</div>
						</div>

						<!-- Submit and Clear button -->
						<div class="mt-5 mb-5 action-buttons">
							<button
								type="submit"
								class="btn btn-primary mr-2"
								@click.prevent="submitClassTrialForm"
							>
								{{ $t("submit") }}
							</button>
						</div>
					</form>
				</div>
				<!-- Class Trial Behavior Table -->
				<div class="col-md-6">
					<student-profile-tab-placement-class-trial-behavior-table
						:placementId="props.rowData.id"
					/>
				</div>
				<!-- Class Trial Skills Table -->
				<div class="col-md-6">
					<student-profile-tab-placement-class-trial-skills-table
						:placementId="props.rowData.id"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { ClassTrialFormMixin } from "./ClassTrialFormMixin.js";
import GlobalHelperMixin from "../../../../../../../Mixins/global/GlobalHelperMixin";
import { UserMixin } from "../../../../../Auth/Mixins/UserMixin";

export default {
	name: "ClassTrial",
	mixins: [ClassTrialFormMixin, GlobalHelperMixin, UserMixin],
	props: {
		value: {
			type: Object,
			default: () => {
				return {
					code: "",
					name: "",
					is_active: "",
				};
			},
		},
		studentProfilePlacementSubTabLists: {
			type: Array,
			default: () => {
				return [];
			},
		},
		props: {
			type: Object,
			default: () => {
				return {};
			},
		},
	},
	data() {
		return {
			preloader: false,
			classTrialForm: {
				created_by: this.props.rowData.created_by?.id || "",
				completed_by: this.props.rowData.completed_by?.id || "",
				center_id: this.props.rowData.center_id || "",
				booked_date: this.props.rowData.booked_date || "",
				course_id: this.props.rowData.course_id?.id || "",
				sub_status: this.props.rowData.sub_status?.id || "",
				booked_time: this.props.rowData.booked_time || "",
			},
			subStatusLists: [],
			assignedByLists: [],
			completedByLists: [],
			centerLists: [],
			input_course_id: this.value
				? this.value.course
					? {
							id: this.value.course.id || 0,
							course_name: this.value.course.course_name || "",
							is_active: this.value.course.is_active,
					  }
					: {
							id: this.value.course?.id || 0,
							course_name: this.value.course?.course_name || "",
							is_active: this.value.course?.is_active,
					  }
				: {
						id: this.value.course.id || 0,
						course_name: this.value.course.course_name || "",
						is_active: this.value.course.is_active,
				  },
			input_sub_status: this.value
				? this.value.sub_status
					? {
							id: this.value.sub_status.id || 0,
							status: this.value.sub_status.status || "",
					  }
					: {
							id: this.value.sub_status?.id || 0,
							status: this.value.sub_status?.status || "",
					  }
				: {
						id: this.value.sub_status.id || 0,
						status: this.value.sub_status.status || "",
				  },
		};
	},
	created() {
		this.fetchData();
		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		} else {
			this.classTrialForm.completed_by = this.user.loggedInUser.id;
		}
	},
	methods: {
		async fetchData() {
			try {
				let [subStatusResponse, userResponse, centerResponse] =
					await Promise.all([
						axios.get(
							"/master/lead-status?lead_status_id=3&per_page=100"
						),
						axios.get("/user-list?per_page=100"),
						axios.get("/master/center?per_page=50"),
					]);

				subStatusResponse.data.data.forEach((item) => {
					this.subStatusLists.push({
						id: item.id,
						value: item.status,
					});
				});

				userResponse.data.data.forEach((item) => {
					this.assignedByLists.push({
						id: item.id,
						value: item.full_name,
					});
					this.completedByLists.push({
						id: item.id,
						value: item.full_name,
					});
				});

				centerResponse.data.data.forEach((item) => {
					this.centerLists.push({
						id: item.id,
						value: item.name,
					});
				});
			} catch (error) {
				console.error("Error fetching data:", error);
			}
		},
		// CLASS TRIAL FORM
		beforeSubmitClassTrialForm() {
			this.preloader = true;
		},
		submitClassTrialForm() {
			this.classTrialForm.booked_date = this.formattedDate(
				this.classTrialForm.booked_date
			);
			this.saveClassTrialForm(this.classTrialForm);
		},
		afterSuccessClassTrialForm(res) {
			this.$toastr.s(res.data.message);
			// this.clearClassTrialForm();
		},
		afterFinalResponseClassTrialForm() {
			this.preloader = false;
		},
		afterErrorClassTrialForm(res) {
			if (res === undefined) {
				return;
			} else if (res.data === undefined) {
				return;
			} else if (res.data.message === undefined) {
				return;
			} else {
				this.$toastr.e(res.data.message);
			}
		},
		clearClassTrialForm() {
			// Clear form fields here
			this.classTrialForm = {};
			// this.classTrialForm.custom_file = null;
		},
		setCourseIdValue(data) {
			this.classTrialForm.course_id = data.id;
			if (data && data.hasOwnProperty("id")) {
				this.classTrialForm.course_id = data.id;
			}
		},
		formattedDate(payloadDate) {
			const originalDate = payloadDate;
			const date = new Date(originalDate);

			const year = date.getFullYear();
			const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
			const day = date.getDate().toString().padStart(2, "0");

			const hour = date.getHours().toString().padStart(2, "0");
			const minute = date.getMinutes().toString().padStart(2, "0");
			const second = date.getSeconds().toString().padStart(2, "0");

			const formattedDate = `${year}-${month}-${day} ${hour}:${minute}:${second}`;

			return formattedDate;
		},
		setSubStatusValue(data) {
			this.classTrialForm.sub_status = this.classTrialForm.sub_status;
			if (data && data.hasOwnProperty("id")) {
				this.classTrialForm.sub_status = data.id;
			}
		},
	},
};
</script>

<style scoped>
.ml-40 {
	margin-left: 40px; /* You can adjust the margin value as needed */
}
.mt-8 {
	margin-top: 80px;
}
.mb-8 {
	margin-bottom: 80px;
}
.form-control {
	border: 3px solid; /* You can adjust the border color and width as needed = #c41a1a !important; */
}
</style>
